import { render } from "./PaymentMethodSelect.vue?vue&type=template&id=1b97e3aa&scoped=true"
import script from "./PaymentMethodSelect.vue?vue&type=script&lang=js"
export * from "./PaymentMethodSelect.vue?vue&type=script&lang=js"

import "./PaymentMethodSelect.vue?vue&type=style&index=0&id=1b97e3aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b97e3aa"

export default script